import React from 'react';
import { InfoBlock } from '@picsio/ui';
import { AutoSuggestUp } from '@picsio/icons';
import l10n from '../../../../shared/strings';

import styles from './styles.module.scss';

const PromoBlock = ({ onClose }) => (
  <InfoBlock
    className={styles.wrapper}
    icon={AutoSuggestUp}
    iconColor="primary"
    onClose={onClose}
  >
    <>
      <strong className={styles.title}>{l10n.TRANSCRIPT.promoBlock.title}</strong>
      {l10n.TRANSCRIPT.promoBlock.description}
    </>
  </InfoBlock>
);

export default PromoBlock;
